import { SectionHeading } from './SectionHeading'

const skillGroups = [
  {
    label: '開発リード',
    body: 'クライアントへのヒアリングから要件定義、技術選定、アーキテクチャ設計、タスク分解、コードレビューまでを担当'
  },
  {
    label: 'フロントエンド',
    body: 'Next.js / React / TypeScript / Tailwind CSS / shadcn を用いた業務アプリケーションUIの設計・実装'
  },
  {
    label: 'バックエンド',
    body: 'Hono / Zodを用いたREST APIの設計・実装、Drizzle ORM / Prismaによるデータアクセス層の実装、マルチテナントを意識したデータベース設計'
  },
  {
    label: 'インフラ・運用',
    body: 'GCP / Terraformによるインフラ構築、ステージング・本番環境の分離、CI/CD、Dockerを用いた運用基盤の整備'
  },
  {
    label: '外部連携',
    body: 'Stripe決済、LINE Messaging API、生成AI / LLMを用いたエージェントシステムの設計・実装'
  },
  {
    label: '改善・移行',
    body: 'NoSQLからSQLへのアーキテクチャ移行、Turborepoによるモノレポ開発、単体テスト・統合テストの導入'
  }
]

export const WorkDetail = () => {
  return (
    <section id="skills" className="py-12 border-t border-ink-100">
      <SectionHeading number="06" title="経験・スキル" />
      <dl className="space-y-4">
        {skillGroups.map(({ label, body }) => (
          <div
            key={label}
            className="grid gap-1 sm:grid-cols-[8rem_1fr] sm:gap-6"
          >
            <dt className="font-mono text-xs tracking-wider text-ink-600 pt-[3px]">
              {label}
            </dt>
            <dd className="text-base leading-[1.9] text-ink-800">{body}</dd>
          </div>
        ))}
      </dl>
    </section>
  )
}
